module.exports = __webpack_public_path__ + "../resources/img/ic_re_check.4970fbb5.svg";